import React from "react";
import { Box, Button, Flex, Spinner, Text } from "@chakra-ui/react";
import {
  REQUEST_STATUS_LABEL,
  REQUEST_STATUS_STRING_LABEL,
} from "../config";

// ===== Bộ nút đồng bộ tông teal/xanh của app (không dùng xám) =====
const BTN_SIZE = { base: "sm", md: "md" };

export const PrimaryButton = ({ size = BTN_SIZE, ...props }) => (
  <Button
    size={size}
    bgImage="var(--color-button)"
    color="white"
    fontWeight={600}
    _hover={{ bgImage: "var(--color-button)", opacity: 0.92 }}
    _active={{ opacity: 0.85 }}
    _disabled={{ opacity: 0.45, cursor: "not-allowed" }}
    {...props}
  />
);

export const OutlineButton = ({ size = BTN_SIZE, ...props }) => (
  <Button
    size={size}
    variant="outline"
    bg="white"
    borderColor="var(--color-secondary)"
    color="var(--color-secondary)"
    fontWeight={600}
    _hover={{ bg: "var(--bg-option-employee)" }}
    _active={{ bg: "var(--bg-option-employee)" }}
    {...props}
  />
);

export const GhostButton = ({ size = BTN_SIZE, ...props }) => (
  <Button
    size={size}
    variant="ghost"
    bg="transparent"
    color="var(--color-secondary)"
    fontWeight={600}
    _hover={{ bg: "var(--bg-option-employee)" }}
    {...props}
  />
);

export const Card = ({ children, ...props }) => (
  <Box
    bg="white"
    borderRadius="12px"
    border="1px solid var(--border-input-employee)"
    boxShadow="0px 1px 4px rgba(0,0,0,0.04)"
    p={{ base: "16px", md: "20px" }}
    {...props}
  >
    {children}
  </Box>
);

export const PageHeader = ({ title, subtitle, right }) => (
  <Flex
    align="center"
    justify="space-between"
    mb={{ base: "16px", md: "20px" }}
    gap="12px"
    flexWrap="wrap"
  >
    <Box>
      <Text
        fontSize={{ base: "18px", md: "22px" }}
        fontWeight={700}
        color="var(--color-header-employee)"
      >
        {title}
      </Text>
      {subtitle && (
        <Text fontSize="13px" color="var(--color-label-employee)" mt="2px">
          {subtitle}
        </Text>
      )}
    </Box>
    {right}
  </Flex>
);

export const Loading = ({ label = "Đang tải..." }) => (
  <Flex direction="column" align="center" justify="center" py="40px" gap="12px">
    <Spinner thickness="3px" speed="0.65s" color="var(--color-secondary)" size="lg" />
    <Text fontSize="13px" color="var(--color-label-employee)">
      {label}
    </Text>
  </Flex>
);

export const EmptyState = ({ label = "Chưa có dữ liệu" }) => (
  <Flex direction="column" align="center" justify="center" py="40px" gap="8px">
    <Box fontSize="40px">📭</Box>
    <Text fontSize="14px" color="var(--color-label-employee)">
      {label}
    </Text>
  </Flex>
);

export const InfoRow = ({ label, children }) => (
  <Flex justify="space-between" gap="16px" py="8px" borderBottom="1px solid #F1F4F9">
    <Text fontSize="13px" color="var(--color-label-employee)" flexShrink={0}>
      {label}
    </Text>
    <Box fontSize="13px" fontWeight={600} color="var(--color-info-employee)" textAlign="right">
      {children ?? "-"}
    </Box>
  </Flex>
);

// Badge trạng thái, chấp nhận status kiểu số (1/2/3) hoặc chuỗi (PENDING/APPROVED/REJECTED)
export const StatusBadge = ({ status }) => {
  const isString = typeof status === "string";
  const normalized = isString ? status.toUpperCase() : status;
  const label = isString
    ? REQUEST_STATUS_STRING_LABEL[normalized] || status
    : REQUEST_STATUS_LABEL[normalized] || "—";

  const approved = normalized === 2 || normalized === "APPROVED";
  const rejected = normalized === 3 || normalized === "REJECTED";

  const palette = approved
    ? { bg: "#E9FFF1", color: "#18C758" }
    : rejected
    ? { bg: "#FFF0F0", color: "#EF2E14" }
    : { bg: "#FFF7E6", color: "#F79D0D" };

  return (
    <Box
      display="inline-block"
      bg={palette.bg}
      color={palette.color}
      fontSize="12px"
      fontWeight={600}
      px="10px"
      py="3px"
      borderRadius="999px"
      whiteSpace="nowrap"
    >
      {label}
    </Box>
  );
};
